module.exports = __webpack_public_path__ + "img/159.7f63b2df.jpg";